import { useContext } from 'react';

import { DataTableContext, DataTableContextValue } from '../DataTableContext.js';
import { DataTableRow } from '../DataTableTypes.js';

export const useDataTableContext = <TRow extends DataTableRow, TContext = unknown>() => {
  const ctx = useContext<DataTableContextValue<TRow, TContext> | null>(DataTableContext as any);

  if (!ctx) {
    throw new Error('useDataTableContext must be used within a DataTable');
  }

  return ctx;
};
